module.exports = __webpack_public_path__ + "static/media/8OLA14.2f76b463.jpg";